export class ELIMSData {

    StationCode: string;
    StationName: string;
    ClientName: string;
    ClientZipCode: string;
    ClientCity: string;

    static mapFromJSON(json): ELIMSData {
        const d = new ELIMSData();

        d.ClientCity = json.clientCity;
        d.ClientZipCode = json.clientZipCode;
        d.ClientName = json.clientName;
        d.StationCode = json.stationCode;
        d.StationName = json.stationName;

        return d;
    }
}
